module.exports = __webpack_public_path__ + "img/EMD.c41e0758.png";